export const GET_TRANSCRIPTS_BEGIN = 'get_transcripts_begin';
export const GET_TRANSCRIPTS_REQUESTING = 'get_transcripts_requesting';
export const GET_TRANSCRIPTS_SUCCESS = 'get_transcripts_success';
export const GET_TRANSCRIPTS_ERROR = 'get_transcripts_error';
export const GET_TRANSCRIPTS_RESET = 'get_transcripts_reset';

export const GET_TRANSCRIPT_BEGIN = 'get_transcript_begin';
export const GET_TRANSCRIPT_REQUESTING = 'get_transcript_requesting';
export const GET_TRANSCRIPT_SUCCESS = 'get_transcript_success';
export const GET_TRANSCRIPT_ERROR = 'get_transcript_error';
export const GET_TRANSCRIPT_RESET = 'get_transcript_reset';